/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { lazy, Suspense } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import '../globals.scss'
// import { Link, ScrollTracking } from '@ta-interaktiv/contentbricks'
// import { MDXProvider } from '@mdx-js/react'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { MetaInfos } from '../metaInfos'

import { StandaloneIFrame } from 'components/standaloneIFrame'
// import { R0Chart } from 'components/R0Chart'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import { HospChart } from 'components/hospChart'
import { HospVaccChart } from 'components/hospVaccChart'
import { HospReasonChart } from 'components/hospReasonChart'
import { DeathChart } from 'components/deathChart'
import { DeathVaccChart } from 'components/deathVaccChart'
import { DeathVaccTable } from 'components/deathVaccTable'
import { DeathVaccTableU60 } from 'components/deathVaccTableU60'
import { VaccAgeGroup } from 'components/vaccAgeGroup'
import DataWrapperChart from 'components/DataWrapperChart'
import { ArticleTeaserCarousel } from '../ArticleTeaserCarousel'
import { WastewaterCharts } from 'components/WastewaterCharts'
import { SectionTitle } from 'components/SectionTitle'
import { Facts } from 'components/Facts/component'
import { Link } from '@ta-interaktiv/contentbricks'

const CantonMultiples = lazy(() =>
  import('components/cantonMultiples/component')
)

// TODO Set the correct article ID here
const ARTICLE_ID = '18727947'
const checkIsMobile = window.innerWidth < 712

/* Simple example */
const ADDITIONAL_SHARES = 181

export function AppComponent() {
  return (
    <div className='index'>
      {/* <MDXProvider
        components={{
          a: Link
        }}
      > */}
      <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
      <ThemeSwitch />
      {/* <ScrollTracking /> */}
      <>
        <ArticleTeaserCarousel articleIdToRemove={ARTICLE_ID} />
        <header className='ui vertical very fitted segment noBorder '>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Die neusten Zahlen zur Corona-Pandemie</h1>
              <h2>
                Wie sich die wichtigsten Kennzahlen dieser Epidemie in der
                Schweiz und auch auf der Welt entwickeln.
              </h2>
            </div>
          </div>
        </header>

        <Segment additionalClasses='fitted noBorder'>
          <TextColumn>
            <>
              <div className='info'>
                Die Grafiken in dieser Übersicht werden{' '}
                <b className='bold'>ab dem 14. November 2023 nicht mehr aktualisiert</b>. Die breite
                Überwachung der Zirkulation verschiedener Viren zeigen wir in zusammengefasster
                und übersichtlicher Form in einem neuen{' '}
                <Link href='261114500647'>interaktiven Dashboard</Link>.
              </div>
              <MetaInfos
                authors={['Interaktiv-Team']}
                // updated='Wird laufend aktualisiert'
              />
              <Facts isMobile={checkIsMobile} />
            </>
          </TextColumn>
        </Segment>

        <Segment additionalClasses='relaxed grey '>
          <WideColumn>
            <>
              <SectionTitle
                main='Kantone, Länder, Kontinente'
                sub='In dieser interaktiven Grafik können Sie Länder, Kontinente oder Kantone miteinander vergleichen. Ob Sie dabei Todesfälle und Infektionen absolut, relativ, kumuliert oder als neue Fälle anzeigen wollen, ist Ihnen überlassen.'
                update='Wird täglich aktualisiert'
              />
              <StandaloneIFrame
                url={`https://interaktiv.${
                  parseHostname().publicationDomain
                }/2020/covid-laendervergleich-embed/embed.html?int=true&dm=false`}
                id='countycompare'
                initialHeight={1300}
              />
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed '>
          <WideColumn additionalClasses='chart'>
            <WastewaterCharts />
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed '>
          <WideColumn>
            <>
              <SectionTitle
                main='Covid-19-Patienten im Spital'
                update='Wird dienstags aktualisiert'
              />
              <div
                style={{
                  textAlign: 'center',
                  fontFamily: 'var(--chart-font-stack)',
                  fontSize: '12px',
                  color: '#888',
                  lineHeight: '1.3em'
                }}
              >
                Seit 1. Mai 2023 werden diese Daten vom BAG nicht mehr
                publiziert.
              </div>
              <StandaloneIFrame
                url={
                  'https://interaktiv.' +
                  parseHostname().publicationDomain +
                  '/2020/covid-swiss-hospitalization-embed/embed.html?link=no&header=no'
                }
                id='hospitalization'
                initialHeight={1050}
              />
              <TextColumn additionalClasses='spaceBefore'>
                <HospReasonChart />
              </TextColumn>
            </>
          </WideColumn>
        </Segment>
        {/* <Segment additionalClasses='relaxed '>
          <WideColumn>
            <>
              <SectionTitle
                main='Hospitalisierte nach Impfstatus'
                update='Wird dienstags aktualisiert'
              />

              <HalfLeft additionalClasses='first'>
                <HospVaccChart />
              </HalfLeft>
              <HalfRight additionalClasses='first'>
                <DeathVaccChart />
              </HalfRight>
              <HalfLeft additionalClasses='last'>
                <DeathVaccTable />
              </HalfLeft>
              <HalfRight additionalClasses='last'>
                <DeathVaccTableU60 />
              </HalfRight>
            </>
          </WideColumn>
        </Segment> */}
        <Segment additionalClasses='relaxed grey'>
          <WideColumn>
            <>
              <SectionTitle
                main='Über- bzw. Untersterblichkeit'
                update='Wird dienstags aktualisiert'
              />
              <StandaloneIFrame
                url={
                  'https://interaktiv.' +
                  parseHostname().publicationDomain +
                  '/2020/uebersterblichkeit-wegen-coronavirus/embed.html?emb=1&hideregions=1&hideflag=1'
                }
                id='uebersterblichkeit'
                initialHeight={930}
              />
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed'>
          <WideColumn additionalClasses='chart'>
            <>
              <SectionTitle
                main='Impffortschritt'
                update='Wird dienstags aktualisiert'
              />
              <HalfLeft additionalClasses='first'>
                <DataWrapperChart
                  chartId='UOHjk'
                  height={checkIsMobile ? 503 : 505}
                />
              </HalfLeft>
              <HalfRight additionalClasses='first'>
                <VaccAgeGroup />
              </HalfRight>
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed '>
          <WideColumn additionalClasses='chart'>
            <>
              <SectionTitle main='Tests' update='Wird dienstags aktualisiert' />
              <HalfLeft additionalClasses='first'>
                <DataWrapperChart
                  chartId='kJs1R'
                  height={checkIsMobile ? 503 : 505}
                />
              </HalfLeft>
              <HalfRight additionalClasses='first'>
                <DataWrapperChart
                  chartId='PB5KS'
                  height={checkIsMobile ? 503 : 505}
                />
              </HalfRight>
              <HalfLeft>
                <DataWrapperChart
                  chartId='J5yCk'
                  height={checkIsMobile ? 480 : 500}
                />
              </HalfLeft>
              {/* <HalfRight additionalClasses='last'>
                <R0Chart isMobile={checkIsMobile} />
              </HalfRight> */}
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed'>
          <WideColumn additionalClasses='chart'>
            <>
              <SectionTitle
                main='Mögliche Langzeitfolgen'
                update='Wird monatlich aktualisiert'
              />
              <TextColumn>
                <DataWrapperChart
                  chartId='LyGKb'
                  height={checkIsMobile ? 466 : 523}
                />
              </TextColumn>
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed grey'>
          <WideColumn additionalClasses='chart'>
            <>
              <SectionTitle
                main='Bestätigte Fälle und Todesfälle in den Kantonen'
                update='Wird dienstags aktualisiert'
              />
              <Suspense
                fallback={
                  <Loader>
                    Lade Neuninfektionen und tägliche Todesfälle in Kantonen...
                  </Loader>
                }
              >
                <CantonMultiples isMobile={checkIsMobile} />
              </Suspense>
            </>
          </WideColumn>
        </Segment>
        <Segment additionalClasses='relaxed'>
          <WideColumn additionalClasses='chart'>
            <>
              <SectionTitle
                main='Todesfälle und Hospitalisierte nach Altersgruppen'
                update='Wird dienstags aktualisiert'
              />
              <HalfLeft additionalClasses='first last'>
                <DeathChart />
              </HalfLeft>
              <HalfRight additionalClasses='first last'>
                <HospChart />
              </HalfRight>
            </>
          </WideColumn>
        </Segment>

        <Segment additionalClasses='relaxed'>
          <WideColumn>
            <>
              {/* <SectionTitle
                main='International'
                update='Wird täglich aktualisiert'
              /> */}

              <StandaloneIFrame
                url={
                  'https://interaktiv.' +
                  parseHostname().publicationDomain +
                  '/2021/embed_europe_incidence_map/'
                }
                id='europemap'
                initialHeight={checkIsMobile ? 700 : 1000}
              />

              {/* <FullWidth>
                <DataWrapperChart chartId='nnfxe' />
              </FullWidth> */}
            </>
          </WideColumn>
        </Segment>
        <div style={{ width: '100%', clear: 'both' }} />
        <Footer
          additionalShares={ADDITIONAL_SHARES}
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Konzept, Recherche, Umsetzung',
              'Marc Brupbacher, Jonas Nart, Patrick Vögeli, Sebastian Broschinski, Mathias Lutz, Andreas Moor'
            ],
            [
              'Daten',
              'BAG, European Centre for Disease Prevention and Control, basierend auf Daten der WHO, verschiedenen nationalen Gesundheitsbehörden und Agenturen. Die Daten werden jeweils morgens aktualisiert. Daten zum R-Wert  stammen von der ETH Zürich. Zahlen zur Übersterblichkeit vom Bundesamt für Statistik (BFS).'
            ]
          ]}
        />
      </>
      {/* </MDXProvider> */}
    </div>
  )
}

const Loader = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <Segment>
    <div className={'ui active inverted dimmer ' + additionalClasses}>
      <div className='ui text loader'>{children}</div>
    </div>
  </Segment>
)
const Segment = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui vertical ' + additionalClasses + ' segment'}>
    {children && children}
  </div>
)
const WideColumn = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'ui container ' + additionalClasses}>
    {children && children}
  </div>
)
const TextColumn = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div
    className={'ui text container ' + additionalClasses}
    style={{
      // marginBottom: '30px',
      borderBottom: checkIsMobile ? undefined : '˘1px solid #eee',
      paddingBottom: checkIsMobile ? '20px' : undefined
    }}
  >
    {children && children}
  </div>
)
const HalfLeft = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w50 left ' + additionalClasses}>
    {children && children}
  </div>
)
const HalfRight = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w50 right ' + additionalClasses}>
    {children && children}
  </div>
)
const FullWidth = ({
  children,
  additionalClasses = ''
}: {
  children?: string | JSX.Element
  additionalClasses?: string
}) => (
  <div className={'gContainer w100 ' + additionalClasses}>
    {children && children}
  </div>
)
